/**
 * en-GB messages added by Phase 4 task W29 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 * Everything a visitor sees uses a visitor prefix (`public.`, `forms.public.`, `privacy.public.`, `prearrival.`) so TR1 translates it.
 */
export const w29EnGB = {
    // Shared parts of the public pages
    'public.language.label': 'Language',
    'public.yourData': 'Your data',
    'public.loading': 'Loading',
    'public.retry': 'Try again',
    'public.invalid.title': 'This page is not available',
    'public.invalid.body': 'The address may be wrong, out of date or switched off. Please ask the organisation that sent it to you.',
    'public.problem': 'Something went wrong. Please try again in a moment.',
    'public.rateLimited': 'Too many attempts. Please wait a few minutes and try again.',
    'public.required': 'This is required',
    'public.footer': 'Provided by CloudSign.',
    'public.yes': 'Yes',
    'public.no': 'No',
    'public.choose': 'Choose',
    // Pre-registration form page
    'forms.public.siteLine': '{site}, {tenant}',
    'forms.public.name': 'Your full name',
    'forms.public.email': 'Email address',
    'forms.public.phone': 'Phone number',
    'forms.public.company': 'Company',
    'forms.public.host': 'Who are you visiting?',
    'forms.public.hostHint': 'Type their full name as they would give it.',
    'forms.public.date': 'Date of visit',
    'forms.public.time': 'Expected arrival time',
    'forms.public.dateHint': 'Up to {days} days ahead, in the time at {site}.',
    'forms.public.questions': 'A few more questions',
    'forms.public.privacy': 'Read the privacy information',
    'forms.public.submit': 'Register my visit',
    'forms.public.submitting': 'Sending',
    'forms.public.honeypot': 'Leave this empty',
    'forms.public.thanks.title': 'Thank you',
    'forms.public.thanks.pending': 'Your request has been received and is waiting for approval. We will email you when it is decided.',
    'forms.public.thanks.approved': 'You are registered. Check your email for your arrival details.',
    'forms.public.again': 'Register another visit',
    // Privacy page and data requests
    'privacy.public.title': 'Your data at {name}',
    'privacy.public.notice': 'Privacy notice',
    'privacy.public.noticeLink': 'Read the full privacy notice',
    'privacy.public.selfServiceOff': 'To make a request about your data, please contact {name} using the details in the privacy notice.',
    'privacy.public.requestTitle': 'Make a request about your data',
    'privacy.public.kind': 'What would you like to do?',
    'privacy.public.kind.access': 'See the data you hold about me',
    'privacy.public.kind.rectification': 'Correct data about me',
    'privacy.public.kind.erasure': 'Delete data about me',
    'privacy.public.kind.stop_marketing': 'Stop marketing messages',
    'privacy.public.name': 'Your full name',
    'privacy.public.email': 'Email address',
    'privacy.public.phone': 'Phone number',
    'privacy.public.contactHint': 'Give the email address or phone number you used when you visited. We send a code to prove it is you.',
    'privacy.public.contactNeeded': 'Please give an email address or a phone number.',
    'privacy.public.details': 'What is wrong, and what should it be?',
    'privacy.public.send': 'Send me a code',
    'privacy.public.sentEmail': 'If we hold a record with that address, we have sent a 6-digit code to it. It is valid for a short time.',
    'privacy.public.sentSms': 'If we hold a record with that number, we have sent a 6-digit code to it by text message. It is valid for a short time.',
    'privacy.public.code': '6-digit code',
    'privacy.public.verify': 'Confirm',
    'privacy.public.codeWrong': 'That code did not work. Please check it and try again.',
    'privacy.public.done.title': 'Request received',
    'privacy.public.done.reference': 'Your reference is {reference}.',
    'privacy.public.done.completed': 'Your request is complete.',
    'privacy.public.done.open': 'We will deal with your request and write to you.',
    'privacy.public.done.status': 'Check the progress of your request',
    'privacy.public.status.title': 'Your request {reference}',
    'privacy.public.status.kind': 'Request',
    'privacy.public.status.state': 'Status',
    'privacy.public.status.received': 'Received',
    'privacy.public.status.due': 'We will answer by',
    'privacy.public.status.decision': 'Our decision',
    'privacy.public.status.download': 'Download your data',
    'privacy.public.status.unverified': 'Waiting for your code',
    'privacy.public.status.open': 'Being dealt with',
    'privacy.public.status.approved': 'Approved',
    'privacy.public.status.refused': 'Refused',
    'privacy.public.status.completed': 'Complete',
    'privacy.public.status.cancelled': 'Cancelled',
    'privacy.public.status.expired': 'Expired',
    'privacy.public.export.title': 'Download your data',
    'privacy.public.export.body': 'Your data is ready as a ZIP file. The link works for 7 days. Keep the file safe, because it holds personal information.',
    'privacy.public.export.button': 'Download ZIP file',
    // Pre-arrival page
    'prearrival.wallet.add': 'Add to Google Wallet',
    'prearrival.wallet.hint': 'Keep your arrival pass on your phone.',
    'prearrival.wallet.error': 'We could not make a wallet pass just now. Your QR code above still works.',
};
//# sourceMappingURL=w29.js.map